import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { ChatKeysState, ChatKeysStore } from './chat-keys.store';

@Injectable({
  providedIn: 'root',
})
export class ChatKeysQuery extends Query<ChatKeysState> {
  constructor(protected store: ChatKeysStore) {
    super(store);
  }
}
